import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent, MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ModalAddTradeAgreementComponent } from '../modal-add-trade-agreement/modal-add-trade-agreement.component';

@Component({
  selector: 'app-custom-table-min',
  templateUrl: './custom-table-min.component.html',
  styles: [
  ]
})
export class CustomTableMinComponent implements OnInit {

  displayedColumns_aux: string[] = [];
  private _data: any;
  dataSource: MatTableDataSource<any>;

  roles: any = [];
  usersSelected: any = [];
  users: any = [];
  length = 100;
  pageSize = 20;
  pageSizeOptions: number[] = [10, 20, 50, 100];
  pageEvent: PageEvent;

  dataSourceModal: any = [
    { 'Nombre documento':'documento nombre largo', Formato: '.docx'},
  ];

  displayedColumnsModal: any = [
    {variable: 'Nombre documento', displayedName: 'Nombre documento'},
    {variable: 'Formato', displayedName: 'Formato'},
    {variable: 'options', displayedName: 'Acciones'},
  ];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  @Input() displayedColumns: any = [];
  @Input() options: number = 0;
  @Input() customH: string = '';
  @Output() eventSendActualData = new EventEmitter<any>();
  @Output() eventUpdateData = new EventEmitter<boolean>();

  @Input() set data (value: any) {
    this._data = value;

   if(this._data.length != 0){
    for (let index = 0; index < this._data.length; index++) {
      this._data[index].rowNumber = index + 1;
    }
   }

    this.dataSource = new MatTableDataSource(this.data);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  get data(): any {
    return this._data;
  }

  sendActualData(data: any){
    this.eventSendActualData.emit(data);
  }

  removeProductService(row: any){
    for (let index = 0; index < this.data.length; index++) {
      const element = this.data[index];
      if(element.id == row.id){
        // this.data.splice(index, 1);
        element.status = 'inactive';
      }
    }
    this.dataSource = <any>[...this.data];
    this.sendActualData(this.data);
  }

  editProductService(row: any){
    const dialogRef = this.dialog.open(ModalAddTradeAgreementComponent, {
      // width: '550px',
      disableClose: true,
      data:  {
        row: row,
        showTable: false
      },
      // panelClass: 'content_modal'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != null) {
        this.eventUpdateData.emit();
      }
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


  constructor( public _MatPaginatorIntl: MatPaginatorIntl, public dialog: MatDialog, private router: Router, private toast: ToastrService) {
  }

  ngOnInit(): void {
    // this.displayedColumns.unshift({variable: 'rowNumber', displayedName: 'N.'})
    this.displayedColumns.forEach(element => {
      this.displayedColumns_aux.push(element.variable);
    });

    this._MatPaginatorIntl.itemsPerPageLabel = 'Items por página';
    this._MatPaginatorIntl.previousPageLabel = 'Anterior';
    this._MatPaginatorIntl.nextPageLabel = 'Siguiente';
  }
}

